module.exports = "<div class=c-form__field> <input type=text class=c-form__input id=new-password name=new-password ng-model=$ctrl.password ng-change=$ctrl.checkStrength() autocomplete=new-password ng-minlength=8 ng-maxlength=50 ng-disabled=$ctrl.saving required/> <label class=c-form__label for=new-password>Account Password</label> </div> <div class=c-strength-meter> <div class=c-strength-meter__fill data-strength=\"{{ $ctrl.strength.score || 0 }}\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/user/views/password.input.html
// module id = 880
// module chunks = 0